export default "__VITE_ASSET__D20DL0SN__"